import { combineReducers } from 'redux';
import { SearchStyle } from '../Config';
import page from './page';
import getSearchReducer from './search';
import articleFeedback from './articleFeedback';
// Just to help out testing
export const defaultConfig = {
    searchStyle: SearchStyle.resultsPage,
};
function getReducer(config = defaultConfig) {
    return combineReducers({
        articleFeedback,
        page,
        search: getSearchReducer(config),
    });
}
export default getReducer;
//# sourceMappingURL=index.js.map